import { render, staticRenderFns } from "./acticePeopleForm.vue?vue&type=template&id=3ad84308&scoped=true&"
import script from "./acticePeopleForm.vue?vue&type=script&lang=js&"
export * from "./acticePeopleForm.vue?vue&type=script&lang=js&"
import style0 from "./acticePeopleForm.vue?vue&type=style&index=0&id=3ad84308&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad84308",
  null
  
)

export default component.exports